import React, {useEffect, useState} from 'react';
import {useSearchParams} from "react-router-dom";
import axios from "axios";
import {API_BASE_URL} from "../config";
import Loading from "../components/Loading";

const ResetPassword = () => {

    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const token = searchParams.get("token");
    const [passwordVisible, setPasswordVisible] = useState(false);

    const [newPassword, setNewPassword] = useState("")
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [passwordError, setPasswordError] = useState("")

    useEffect(() => {
        setLoading(true)

        axios.post(`${API_BASE_URL}/check_user_token_password_recovery`, {
            user_id: id, token: token
        })
            .then((res) => {
                console.log(res)
                if (res.data === 'ok') setLoading(false); else if (res.data === 'error') {
                    setLoading(false)
                    setMessage("Token invalide. <br> Merci de réessayer ou de demander un nouveau lien de réinitialisation.")
                }

            })
    }, [token])

    const saveNewPassword = () => {

        console.log(id, newPassword)

        if (newPassword.length < 7) {
            setPasswordError("Merci de rentrer au moins 7 caractères.")
        } else {
            axios.post(`${API_BASE_URL}/user_update_password`, {user_id: id, password: newPassword})
                .then((res) => {
                    console.log(res.data)

                    if (res.data.status === 'ok') {
                        axios.post(`${API_BASE_URL}/get_user_infos_by_id`, {user: id})
                            .then(response => {

                                console.log(response)

                                // Stockage des infos de l'utilisateur en localStorage
                                localStorage.token = response.data.token;
                                localStorage.user_id = response.data[0].id;
                                localStorage.user_mail = response.data[0].email;
                                localStorage.user_role = response.data[0].role;
                                localStorage.color = response.data[0].color;
                                localStorage.user_name = response.data[0].firstname;
                                window.location.href = '/login'
                            });

                    }
                })
        }

    }

    console.log("id:", id, "token:", token);
    return (


        loading ? <Loading/> : (<div className={"display-flex flex-direction-column align-items-center"}>
            {message ? <span className={"display-flex flex-direction-column"} dangerouslySetInnerHTML={{__html :message}} style={{width: "100%", textAlign: "center"}}/> :
                <div className={'display-flex flex-direction-column gap-20 text-center'}>
                    <h3 className={"color-third"}>Réinitialisation de votre mot de passe 😎</h3>
                <label className="form-label flex-2 text-center">
                    Nouveau mot de passe :
                </label>
                    <div style={{ position: "relative", width: "100%" }}>
                        <input
                            type={passwordVisible ? "text" : "password"}
                            className="form-input"
                            onChange={(e) => setNewPassword(e.target.value)}
                            style={{ width: "100%", paddingRight: "40px" }}
                        />

                        <i
                            className={`fa-regular ${passwordVisible ? "fa-eye-slash" : "fa-eye"}`}
                            onClick={() => setPasswordVisible(!passwordVisible)}
                            style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#888"
                            }}
                        ></i>
                    </div>

                <button onClick={saveNewPassword}>Mettre à jour</button>
                {passwordError && <div>{passwordError}</div>}
            </div>}
        </div>)


    )

        ;
};

export default ResetPassword;